import { Component, OnInit } from '@angular/core';
import { Data } from '../../../helper/datastore';
@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
})
export class PopupComponent implements OnInit {
  _errorMessage: string = '';
  _infoMessage: any;

  constructor(public data: Data) {}

  ngOnInit(): void {
    this._errorMessage = this.data._errorMessage;
    //console.log(this._infoMessage);
  }
}
